<div class="documentSourceFileHolder" *ngIf="!isGlobalDocument && !isInternalClientContactLimitedAccess">
  <p-fieldset legend="Document Source File">
    <div class="text-justify">
      <app-label labelText="{{ documentSourceFileHeaderText }}"></app-label>
    </div>
    <div *ngIf="errorMessages.length > 0">
      <p-messages severity="error">
        <ng-template pTemplate>
          <span class="p-message-icon pi pi-times-circle"></span>
          <span class="p-ml-2">
            <app-label labelText="{{ documentErrorReminder }}"></app-label>
          </span>
          <ul>
            <li *ngFor="let errorText of errorMessages">
              <app-label labelText="{{ errorText }}"></app-label>
            </li>
          </ul>
        </ng-template>
      </p-messages>
    </div>
    <p-selectButton
      styleClass="mt-3"
      [options]="templateOptions"
      [(ngModel)]="template"
      optionLabel="label"
      optionValue="value"
      (onOptionClick)="changeTabs($event)"
      [disabled]="ifNotCollaboration"
    ></p-selectButton>
    <div class="grid mt-3" *ngIf="isTemplate">
      <div class="col-4">
        <bpt-dropdown
          label="Document Template*"
          [editable]="false"
          [options]="documentTemplates?? []"
          id="documentTemplate"
          [disabled]="dropDownDisable"
          placeholder="Select Document Template"
          [(ngModel)]="templateId"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          (dropdownChange)="getDocumentTemplateDetails()"
          [ngClass]="{ 'error-highlight': !isDocumentTemplateValid }"
        >
        </bpt-dropdown>
      </div>
      <div class="col-7 ml-3 mt-2 text-primary">
        <div>
          <div class="grid">
            <div class="col max-w-2rem" *ngIf="isDropDownSelected">
              <em
                class="blue-color cursor-pointer"
                (click)="downloadSourceFile(fileId, fileName)"
              >
              <app-file-icon fileType="{{fileType}}"></app-file-icon>
            </em>
            </div>
            <div class="col">
              <app-read-only readonlyText="{{ fileName }}"></app-read-only>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1 max-w-2rem p-0 mt-1" *ngIf="isDropDownSelected">
        <div class="btn">
          <button
            pButton
            pRipple
            class="p-button-rounded bg-white"
            icon="pi pi-trash blue-color cursor-pointer"
            id="deleteSourceFileBtn"
            (click)="openDeleteConfirmationModel()"
            [disabled]="trashIconDisabled"
          ></button>
        </div>
      </div>
    </div>
    <p-dialog
      [(visible)]="showDeletedSourceFileUsingTemplateConfirmationModal"
      [style]="{ width: '30vw' }"
      (onHide)="closeConfirmationModalForDeleteSourceFile()"
      [modal]="true"
    >
      <ng-template pTemplate="header">
        <span class="font-semibold text-xl">Confirmation</span>
      </ng-template>
      <div>
        <div class="grid">
          <div class="col">
            <app-label
              labelText="{{ deleteSourceFileWithTemplateConfirmationMessage }}"
            ></app-label>
          </div>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <p-button
        appPreventDoubleClick
          label="No"
          type="submit"
          icon="pi pi-times"
          id="deletedSourceFilesConfirmationNoButton"
          styleClass="p-button-outlined"
          class="align-right"
          (debounceClick)="closeConfirmationModalForDeleteSourceFile()"
        >
        </p-button>
        <p-button
        appPreventDoubleClick
          label="Yes"
          icon="pi pi-check"
          type="submit"
          id="deletedSourceFilesConfirmationYesButton"
          class="align-right"
          (debounceClick)="updateDocumentAfterDeletionOfSourceFile()"
        >
        </p-button>
        
      </ng-template>
    </p-dialog>
    <div class="grid mt-2" *ngIf="isNoTemplate">
      <div class="col-4">
        <bpt-file-upload
          [disabled]="disableFileUploader"
          [uploadFiles]="uploadSuccess"
          [deleteFile]="deleteSourceFile"
          [fileNames]="isPhaseCollaboration ? savedSourceFiles : []"
          [fileTypes]="documentTemplateFileTypes"
          [fileLimit]="maxFileLimit"
          [maxSize]="maxFileSize"
        ></bpt-file-upload>
      </div>
      <div class="col-6 mt-3 ml-3 text-primary">
        <div>
          <div class="grid">
            <div class="col max-w-2rem" *ngIf="isUpload">
              <em
                class="blue-color cursor-pointer"
                (click)="downloadSourceFile(fileId, fileName)"
              >
              <app-file-icon fileType="{{fileType}}"></app-file-icon>
            </em> 
            </div>
            <div class="col">
              <app-read-only readonlyText="{{ fileName }}"></app-read-only>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p-dialog
      [(visible)]="showTabChangeModal"
      [style]="{ width: '30vw' }"
      [modal]="true"
    >
      <ng-template pTemplate="header">
        <span class="font-semibold text-xl">Confirmation</span>
      </ng-template>
      <div>
        <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
        <span>{{ switchTabsConfirmationMessage }}</span>
      </div>
      <ng-template pTemplate="footer">
        <p-button
        appPreventDoubleClick
          label="No"
          type="submit"
          icon="pi pi-times"
          id="switchTabConfirmationNoButton"
          styleClass="p-button-outlined"
          class="align-right"
          (debounceClick)="tabs()"
        >
        </p-button>
        <p-button
        appPreventDoubleClick
          label="Yes"
          icon="pi pi-check"
          type="submit"
          id="switchTabConfirmationYesButton"
          class="align-right"
          (debounceClick)="switchTabs()"
        >
        </p-button>
        
      </ng-template>
    </p-dialog>
  </p-fieldset>
</div>
<div class="documentAttachmentsHolder" *ngIf="!isInternalClientContactLimitedAccess">
  <p-fieldset legend="Document Attachments">
    <div class="text-justify">
      {{ fileAttachmentsHeaderText }}
    </div>
    <div class="mt-3">
      <bpt-file-upload
        [uploadFiles]="uploadSucceeds"
        [deleteFile]="deleteFile"
        [maxSize]="maxFileSize"
        [fileNames]="savedFiles"
        [fileTypes]="documentAttachmentFileTypes"
        [fileLimit]="documentAttachmentMaxLimit"
      ></bpt-file-upload>
    </div>
  </p-fieldset>
</div>
<div class="clientSignatureAttachmentHolder">
  <p-fieldset legend="Client Signature Attachment" *ngIf="isDocumentEditSlider && clientSignatureAttachmentTabVisible && !isGlobalDocument">
    <div class="text-justify">
      {{ clientSignatureAttachmentHeaderText }}
    </div>
    <div class="mt-3">
      <bpt-file-upload
        [uploadFiles]="uploadSucceedsForClientSignatureAttachment"
        [deleteFile]="deleteFileForClientSignatureAttachment"
        [maxSize]="clientSignatureAttachmentMaxFileSize"
        [fileNames]="savedClientSignatureAttachments"
        [fileTypes]="fileTypes"
        [fileLimit]="clientSignatureAttachmentMaxLimit"
      ></bpt-file-upload>
    </div>
  </p-fieldset>
</div>
<div class="buttons mt-3">
  <p-button
  appPreventDoubleClick
    *ngIf="isDocumentEditSlider"
    label="Save"
    type="submit"
    id="fileSaveButton"
    styleClass="bpt-button-compact"
    class="align-right"
    (debounceClick)="createOrUpdateDocument()"
  >
  </p-button>
  <p-button
  appPreventDoubleClick
    *ngIf="!isInternalClientContactLimitedAccess"
    label="Next"
    type="submit"
    id="filesNextButton"
    styleClass="bpt-button-compact"
    class="align-right mr-3"
    (debounceClick)="openPreviousOrNextTab(true)"
  >
  </p-button>
  <p-button *ngIf="!isGlobalDocument && !isInternalClientContactLimitedAccess"
  appPreventDoubleClick
    label="Previous"
    type="submit"
    styleClass="bpt-button-compact"
    id="filesPreviousButton"
    (debounceClick)="openPreviousOrNextTab(false)"
  >
  </p-button>
</div>
<p-dialog
  [(visible)]="showDeletedFilesConfirmationModal"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ deleteAttachmentConfirmationMessage }}</span>
  </div>
  <ul>
    <li *ngFor="let deleteAttachment of deletedAttachmentsForConfirmation">
      {{ deleteAttachment.attachmentName }}
    </li>
  </ul>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="deletedFilesConfirmationNoButton"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deletedFilesConfirmationYesButton"
      class="align-right"
      (debounceClick)="showConfirmationPopupForDeletedClientSignatureAttachments()"
    >
    </p-button>
    
  </ng-template>
</p-dialog>


<p-dialog
  [(visible)]="showDeletedClientSignatureAttachmentConfirmationModal"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModalForDeletedClientSignatureAttachments()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ deleteClientSignatureAttachmentConfirmationMessage }}</span>
  </div>
  <ul>

      {{ deletedClientSignatureAttachment?.attachmentName }}
  </ul>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="deletedFilesConfirmationNoButton"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeConfirmationModalForDeletedClientSignatureAttachments()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deletedFilesConfirmationYesButton"
      class="align-right"
      (debounceClick)="addReasonToUpdateDocument()"
    >
    </p-button>
    
  </ng-template>
</p-dialog>


<app-dialog *ngIf="isReasonForDocumentUpdateRequired" [heading]="heading" (saveDocumentwithReason)="saveDocumentwithReason($event)" (isModelOpen)="closeReasonDailog($event)">  
</app-dialog>
<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]="InactiveAssignmentGroupField" (confirmed)="saveDocumentwithInactiveAssignmentGroup()" (dialogClosed)="closeConfirmationDailog($event)">
</app-confirmation-dialog>